import React from 'react'

interface InputBoxProps {
  value: string
}

const InputBox: React.FC<InputBoxProps> = ({ value }) => {
  const display = value || ''
  return (
    <div className="bg-white text-black font-medium text-center  transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-flutter-button focus:ring-offset-2 w-[56px] h-[56px] mx-[9px] rounded-[12px] text-[clamp(18px,2vw,24px)] font-['IBM Plex Sans Arabic'] flex items-center justify-center " style={{ direction: 'ltr' }}>
      <span>{display}</span>
    </div>
  )
}

export default InputBox
